// import siteInfo from "@/constants/siteInfo";
import siteInfo from "@/constants/siteInfo";
import Head from "next/head";

const NewsArticleSchema = ({
  title = "",
  description = "",
  keywords = "",
  canonical_url = "",
  image = "",
  publishedAt = "",
  modifiedAt = "",
  createdAt = "",
  authorName = "",
  authorCanonicalUrl = "",
  articleBody = "",
}) => {
  return (
    <Head>
      {/* <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": canonical_url?.includes(
                process.env.NEXT_PUBLIC_WEBSITE_URL
              )
                ? `${canonical_url}`
                : process.env.NEXT_PUBLIC_WEBSITE_URL + `${canonical_url}`,
            },
            headline: title,
            description: description,
            keywords: keywords,
            image: {
              "@type": "ImageObject",
              height: 675,
              width: 1200,
              url: image,
            },
            datePublished: publishedAt,
            dateModified: modifiedAt,
            // dateCreated: createdAt,
            // articleBody: articleBody || description,
            author: {
              "@type": "Person",
              name: authorName,
              url: authorCanonicalUrl?.includes(
                process.env.NEXT_PUBLIC_WEBSITE_URL
              )
                ? `${authorCanonicalUrl}`
                : process.env.NEXT_PUBLIC_WEBSITE_URL + `${authorCanonicalUrl}`,
            },
            publisher: {
              "@type": "Organization",
              name: siteInfo?.siteName,
              logo: {
                "@type": "ImageObject",
                url: `${process.env.NEXT_PUBLIC_WEBSITE_URL}${siteInfo?.newSiteLogo}`,
                height: 60,
                width: 160,
              },
            },
          }),
        }}
      /> */}

      <script
        type="application/ld+json"
        id="NewsArticleSchema1"
        key={"News_Article_Schema_1"}
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            headline: title,
            mainEntityOfPage: canonical_url?.includes(
                process.env.NEXT_PUBLIC_WEBSITE_URL
              )
                ? `${canonical_url}`
                : process.env.NEXT_PUBLIC_WEBSITE_URL + `${canonical_url}`
            ,
            image: {
              "@type": "ImageObject",
              height: 720,
              width: 1280,
              url: image,
            },
            articleBody: articleBody || "",
            description: description,
            ...(keywords && { keywords: keywords }),
            inLanguage: siteInfo.siteLanguage,
            datePublished: publishedAt,
            dateModified: modifiedAt,
            author: {
              "@type": "Person",
              name: authorName,
              url: authorCanonicalUrl?.includes(
                process.env.NEXT_PUBLIC_WEBSITE_URL
              )
                ? `${authorCanonicalUrl}`
                : process.env.NEXT_PUBLIC_WEBSITE_URL + `${authorCanonicalUrl}`,
            },
            publisher: {
              "@type": "Organization",
              name: siteInfo?.siteName,
              url: process.env.NEXT_PUBLIC_WEBSITE_URL,
              logo: {
                "@type": "ImageObject",
                url: `${siteInfo?.newSiteLogo}`,
                height: 60,
                width: 600,
              },
            },
          }),
        }}
      />
    </Head>
  );
};

export default NewsArticleSchema;
